module.exports = __webpack_public_path__ + "img/hiska_neWide.png";